// extracted by mini-css-extract-plugin
module.exports = {"markerPin":"Marker_markerPin__3ANnq","icon":"Marker_icon__3yRMH","text":"Marker_text__3knO5"};